<div class="dynamic-validation">
  <div
    class="dynamic-validation__entry-field entry-field input-label-container"
    [ngClass]="{ 'entry-field--error': isError }"
  >
    <input
      [type]="inputType ? inputType : 'text'"
      class="entry-field__input dynamic-validation__input"
      [ngClass]="{ 'dynamic-validation__input--visible': inputIsVisible }"
      id="{{ componentId }}"
      name="{{ componentId }}"
      [placeholder]="noLabel ? placeholder : '&nbsp;'"
      [(ngModel)]="val"
      (change)="trigger()"
      (keyup)="validateInput(); checkRequirementsMet()"
      (focus)="displayRequirements()"
      (blur)="onblur(); hideRequirements()"
      [maxlength]="maxlength"
    />
    <label
      *ngIf="!noLabel"
      class="entry-field__label"
      for="{{ componentId }}"
      [class.entry-field--error__label]="isError"
    >
      {{ placeholder }}
    </label>
    <p class="error-message error-message--entry-field" *ngIf="isError && !showRequirements">
      {{ errorMessage[prop] }}
    </p>
    <button
      class="dynamic-validation__input-toggle"
      [ngClass]="{ 'dynamic-validation__input-toggle--visible': !fieldIsEmpty() }"
      (click)="toggleInputVisibility()"
    >
      {{ inputIsVisible ? 'Hide' : 'Show' }}
    </button>
  </div>

  <div
    class="dynamic-validation__requirement-container"
    [ngClass]="{
      'dynamic-validation__requirement-container--visible': showRequirements === true,
      'dynamic-validation__requirement-container--error': isError === true
    }"
  >
    Password must include:
    <ng-container *ngFor="let requirement of requirements; index as i">
      <div
        class="dynamic-validation__requirement"
        [ngClass]="{ 'dynamic-validation__requirement--valid': validationResults[i] === true }"
      >
        <div class="dynamic-validation__requirement-icon"></div>
        <p class="dynamic-validation__requirement-description">{{ requirement.description }}</p>
      </div>
    </ng-container>
  </div>
</div>
